<template>
    <v-btn
        type="submit"
        color="secondary"
        depressed
        :disabled="!valid || loading"
        :loading="loading"
        :form="form"
        @click.prevent="submit()"
    >
        <v-icon left>done</v-icon>Submit
    </v-btn>
</template>

<script>
import ApiV2 from '@/lib/ApiV2';
import { toastError } from '@/components/Common/Toast.vue';

export default {
    props: ['value', 'clear', 'valid', 'form', 'prefix'],
    data() {
        return { loading: false };
    },
    methods: {
        async submit() {
            this.$emit('start');
            this.loading = true;
            try {
                const editUsers = [this.value];
                const response = await ApiV2.http
                    .put(this.prefix, editUsers)
                    .then((r) => r.data);
                this.clear();
                this.$emit('http2xx', response);
            } catch (err) {
                toastError(
                    'There was an error encountered while updating this user. If everything looks right please contact support so we can help you :)'
                );
                this.$emit('http4xx', err);
            } finally {
                this.loading = false;
                this.$emit('stop');
            }
        },
    },
};
</script>